import React from 'react';
import classnames from 'classnames';
import { getClassNames } from './SumRow.classNames';
/**
 * @deprecated Komponenten er erstattet av Table.Sum fra "@skatteetaten/ds-table"
 *
 */

export const SumRow = props => {
  const {
    compactTable,
    numberOfColumns,
    sum,
    editableRows,
    expandableRows,
    expandIconPlacement
  } = props;
  const styles = getClassNames(compactTable);
  const columns = numberOfColumns !== 0 ? numberOfColumns - sum.colspan - 1 : 0;
  const emptyCells = Array.from(Array(columns > 0 ? columns : 0).keys());
  let counter = 0;
  return /*#__PURE__*/React.createElement("tr", {
    className: styles.sumRow
  }, /*#__PURE__*/React.createElement("th", {
    colSpan: sum.colspan,
    scope: "row",
    className: classnames(styles.sumCell, 'sumCellIsText')
  }, sum.text), /*#__PURE__*/React.createElement("td", {
    className: classnames(styles.sumCell, 'sumCellIsSum')
  }, sum.total), editableRows && /*#__PURE__*/React.createElement("td", null), expandableRows && expandIconPlacement === 'after' && /*#__PURE__*/React.createElement("td", null), !!emptyCells.length && emptyCells.map(() => /*#__PURE__*/React.createElement("td", {
    key: counter++,
    className: styles.sumCell
  })));
};